import DeliveryService from "../DeliveryService"


const Shop = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    add(data) {
        return DeliveryService.post(`/shops`, data)
    },
    gets() {
        return DeliveryService.get(`/console/shops`)
    },
    get(id) {
        return DeliveryService.get(`/console/shops/` + id)
    },
    getLink(ref_no) {
        return DeliveryService.get(`/shops/` + ref_no + `/link`)
    },
    update(data) {
        return DeliveryService.put(`/console/shops/` + data.ref_no, data)
    },
    sortCategories(data) {
        return DeliveryService.post(`/console/shops/` + data.ref_no + `/sort-categories`, { list: data.list })
    },
    addCategory(data) {
        return DeliveryService.post(`/console/shops/` + data.shop_id + `/categories`, data)
    },
    getCategories(shop_id) {
        return DeliveryService.get(`/console/shops/` + shop_id + `/categories`)
    },
    addServiceArea(data) {
        return DeliveryService.post(`/shops/` + data.shop_id + `/area`, data)
    },
    getServiceArea(id) {
        return DeliveryService.get(`/shops/` + id + `/area`)
    },
    upload(data) {
        var block = data.image.split(";");
        var contentType = block[0].split(":")[1];
        var realData = block[1].split(",")[1];

        var blob = this.b64toBlob(realData, contentType);

        let formData = new FormData();
        formData.append("image", blob);
        formData.append("type", data.type);

        return DeliveryService.upload(`/shops/` + data.shop_id + `/upload`, formData)
    },
    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
            var offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}

export default Shop